'use strict';

;( () => {

	document.addEventListener( 'alpine:init', () => {

		const BREAKPOINTS = {
			'xs'    : 576,
			'sm'    : 640,
			'md'    : 780,
			'lg'    : 1024,
			'xl'    : 1280,
			'canvas': 1440,
			'2xl'   : 1536,
		};

		Alpine.data( 'fillGridRow', () => ({

			_observer        : null,
			_mutationObserver: null,
			_fillerTag       : 'div',
			_breakpoint      : null,

			init() {
				this._fillerTag  = this.$el.dataset.fillerTag || 'div';
				this._breakpoint = BREAKPOINTS[ this.$el.dataset.fillBreakpoint ] || null;
				this._observer   = new ResizeObserver( () => this._fill() );
				this._observer.observe( this.$el );
				this.observeMutations();
				this._fill();
			},

			_fill() {

				if ( this._mutationObserver ) this._mutationObserver.disconnect();

				this.$el.querySelectorAll( '.grid__row-filler' ).forEach( el => el.remove() );

				// Don't fill if the viewport is narrower than the specified breakpoint.
				if ( this._breakpoint && window.matchMedia( `( max-width: ${ this._breakpoint - 1 }px )` ).matches ) {
					if ( this._mutationObserver ) this._mutationObserver.observe( this.$el, { childList: true, subtree: true });
					return;
				}

				const colCount  = getComputedStyle( this.$el ).gridTemplateColumns.split( ' ' ).length;
				const itemCount = this.$el.children.length;
				const fillCount = ( colCount - ( itemCount % colCount ) ) % colCount;

				for ( let i = 0; i < fillCount; i++ ) {
					const filler = document.createElement( this._fillerTag );
					filler.setAttribute( 'aria-hidden', 'true' );
					filler.classList.add( 'grid__row-filler' );
					this.$el.appendChild( filler );
				}

				if ( this._mutationObserver ) {
					this._mutationObserver.observe( this.$el, { childList: true, subtree: true });
				}
			},

			// Create a mutation observer to watch for changes to the grid's
			// children, and trigger a fill when they change. This is necessary
			// because FacetWP replaces the entire grid contents when it
			// updates, which would otherwise break the layout until the next
			// resize event.

			// This needs to work on every run of FacetWP, even if the number of
			// child elements doesn't change.
			observeMutations() {
				this._mutationObserver = new MutationObserver( ( mutations ) => {
					for ( const mutation of mutations ) {
						if ( 'childList' === mutation.type ) {
							this._fill();
							break;
						}
					}
				});
				this._mutationObserver.observe( this.$el, { childList: true, subtree: true });
			},
		}) );
	});
})();
